import { Box, Container } from "@material-ui/core";
import React, { Fragment, useCallback, useEffect } from "react";
import { useIntl } from "react-intl";
import { useHistory, useParams } from "react-router-dom";
import { MeetingEndedPanel } from "../../components/Meeting/MeetingEndedPanel";
import { Locale } from "../../core/api/model";
import { useCurrentUser } from "../../core/hooks/user";
import { useMeeting, useViewAs, ViewAs } from '../hooks/meeting';

interface Props {
  locale: Locale;
  showErrorModal: (title: string, description: string, raw?: any) => void;
}

export const MeetingEnded = ({ locale, showErrorModal }: Props) => {
  const { uuid } = useParams<{ uuid: string }>();
  const intl = useIntl();

  const showError = useCallback(
    (raw?) => {
      showErrorModal(
        intl.formatMessage({
          id: "MeetingEndedErrorTitle",
          defaultMessage: "An error occured.",
        }),
        intl.formatMessage({
          id: "MeetingEndedErrorText",
          defaultMessage: "An error occured. Please try again later.",
        }),
        raw
      );
    },
    [showErrorModal, intl]
  );
  const { meeting } = useMeeting(uuid, showError);
  const { user } = useCurrentUser(showError);
  const viewAs = useViewAs(user, meeting);
  const history = useHistory();

  useEffect(() => {
    if (viewAs in [ViewAs.Forbidden] && meeting?.corporation?.corpId) {
      history.push(`/corp/${meeting?.corporation.corpId}/products`);
    }
  }, [viewAs, meeting, history]);

  return (
    <Box
      component={"main"}
      className="main-background"
      pb={{ xs: 7.5, md: 10 }}
      pt={0.01}
    >
      <Container maxWidth="lg">
        <Fragment>
          {meeting?.expert && meeting?.participant && meeting?.product && (
            <MeetingEndedPanel
              viewAs={viewAs}
              locale={locale}
              corporation={{
                //@ts-ignore
                corpName: meeting.corporation.corpName || {},
              }}
              expert={{
                fullName: `${meeting.expert.partName} ${meeting.expert.partSurname}`,
                title: `${meeting.expert.partTitle}`,
                position: `${meeting.expert.partProfPosition}`,
              }}
              participant={{
                fullName: `${meeting.participant.partName} ${meeting.participant.partSurname}`,
                title: `${meeting.participant.partTitle}`,
                position: `${meeting.participant.partProfPosition}`,
                //@ts-ignore
                corpName: meeting.participant.corporation[0]?.corpName || {},
              }}
              date={{
                startDate: meeting.start,
                endDate: meeting.end,
              }}
              //@ts-ignore
              productName={meeting.product.classificationTitle || {}}
              //@ts-ignore
              productDescription={meeting.product.classificationDesc || {}}
              comment={meeting.request || ""}
              documents={meeting.document ? [meeting.document] : []}
            />
          )}
        </Fragment>
      </Container>
    </Box>
  );
};
